const useLeadSubmitTracking = () => {
  const trackLeadSubmitted = (utms = {}, event) => {
    if (typeof window === 'undefined') return

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: event,
    })
  }

  return trackLeadSubmitted
}

export default useLeadSubmitTracking
